import { Components, Theme, alpha } from '@mui/material';
import { InputProps } from '@/components/Input';

const components: Components<Omit<Theme, 'components'>>['MuiInput'] = {
  styleOverrides: {
    root: ({ theme: { palette, spacing } }) => {
      const isLight = palette.mode === 'light';
      return {
        borderRadius: '4px',
        gap: spacing(1),
        transition: 'all 0.2s',
        padding: spacing(2.5, 3),
        border: isLight
          ? `1px solid ${palette.textColor.A20}`
          : `1px solid ${palette.secondary.A100}`,
        backgroundColor: isLight
          ? palette.grayBackground.A20
          : palette.secondary.A100,
        '&:hover': {
          border: isLight
            ? `1px solid ${palette.textColor.A20}`
            : `1px solid ${palette.base.A60}`,
          backgroundColor: isLight
            ? palette.grayBackground.A20
            : palette.base.A60
        },
        '&.Mui-focused': {
          border: isLight
            ? `1px solid ${palette.textColor.A20}`
            : `1px solid ${palette.primary.A80}`,
          backgroundColor: isLight
            ? palette.grayBackground.A20
            : palette.base.A60
        },
        '&.Mui-error': {
          border: isLight
            ? `1px solid ${palette.error.A100}`
            : `1px solid ${palette.error.A60}`,
          backgroundColor: isLight
            ? palette.base.A0
            : alpha(palette.error.A100 || '', 0.1)
        },
        '&.Mui-disabled': {
          borderColor: isLight
            ? palette.grayBackground.A40
            : palette.secondary.A100,
          backgroundColor: isLight
            ? palette.grayBackground.A10
            : palette.secondary.A100
        }
      };
    },
    input: ({ theme: { palette, spacing } }) => {
      const isLight = palette.mode === 'light';
      return {
        color: isLight ? palette.textColor.A80 : palette.textColor.A0,
        padding: spacing(0),
        '&.Mui-disabled': {
          textFillColor: isLight ? palette.textColor.A40 : palette.textColor.A50
        },
        '&::.placeholder': {
          opacity: 1,
          color: isLight ? palette.textColor.A40 : palette.textColor.A30
        }
      };
    }
  },
  variants: [
    {
      props: { size: 'small' },
      style: ({ theme }) => ({
        fontSize: '14px',
        padding: theme.spacing(1, 3)
      })
    },
    {
      props: { hasBg: true } as InputProps,
      style: ({ theme }) => {
        if (theme.palette.mode === 'light') {
          return {
            border: '1px solid transparent',
            background: theme.palette.secondary.A80
          };
        } else return {};
      }
    },
    {
      props: { success: true } as InputProps,
      style: ({ theme: { palette } }) => ({
        border:
          palette.mode === 'light'
            ? `1px solid ${palette.success.A100}`
            : `1px solid ${palette.success.A40}`,
        backgroundColor:
          palette.mode === 'light'
            ? palette.base.A0
            : alpha(palette.success.A100 as string, 0.1)
      })
    }
  ]
};

export default { components };
